// import { Component, Input, OnInit } from '@angular/core';

import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { map } from 'rxjs';

@Component({
  selector: 'hazmatsuite-next-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @ContentChild('header') header: TemplateRef<any> | null = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @ContentChild('body') body: TemplateRef<any> | null = null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() set items(i: any[]) {
    this.allItems = i;
    this.initializeItems();
  }

  translations$ = this.languageService.translations$.pipe(
    map(data => data['AccountSmartPackagesResource'])
  );


  private step = 10;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public allItems: any[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public currentItemsList: any[] = [];

  public startIndex = 0;
  public endIndex = this.step;
  public isLastPage = true;
  public pageIndex = 1;
  public totalPages = 1;
  public currentPageEntries = 0;
  public totalItems = 0;

  constructor(private languageService: LanguageService) {
    this.languageService.fetchResources(['AccountSmartPackagesResource']);
  }

  initializeItems(): void {
    this.totalPages = Math.ceil(this.allItems.length / this.step);
    if (this.allItems.length < this.endIndex - this.step) {
      this.resetIndex();
    }
    this.selectCurrentItems();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public identify(_: number, item: any) {
    return item.Id;
  }

  public goToFirstPage(): void {
    if (this.startIndex !== 0) {
      this.startIndex = 0;
      this.endIndex = this.step;
    }
    this.selectCurrentItems();
  }

  public goToLastPage(): void {
    this.endIndex = this.totalPages * this.step;
    this.startIndex = this.endIndex - this.step;
    this.selectCurrentItems();
  }

  public goToPreviousPage(): void {
    this.startIndex -= this.step;
    this.endIndex -= this.step;
    this.selectCurrentItems();
  }

  public goToNextPage(): void {
    this.startIndex += this.step;
    this.endIndex += this.step;
    this.selectCurrentItems();
  }

  private selectCurrentItems(): void {
    this.isLastPage = this.endIndex >= this.allItems.length;
    this.currentItemsList = this.allItems.slice(this.startIndex, this.isLastPage ? this.allItems.length : this.endIndex);
    this.pageIndex = this.startIndex === 0 ? 1 : (this.startIndex / this.step) + 1;
    this.currentPageEntries = this.currentItemsList.length;
    this.totalItems = this.allItems.length;
  }

  private resetIndex(): void {
    this.startIndex = 0;
    this.endIndex = this.step;
  }
}
